module.exports = __webpack_public_path__ + "img/target_w.28740540.svg";